"use client";

import { c as _c } from "react/compiler-runtime";
import Image from "@/components/ui/CardImage";
import React from "react";
type TeamRow = {
  name: string;
  short: string;
  logo?: string; // optional logo path
  badge?: string; // hex for badge bg
  played: number;
  won: number;
  lost: number;
  nrr: string; // "+0.812"
  pts: number;
};

// JSON: All dynamic data lives here
const TABLE_DATA: {
  headingLeft: string;
  columns: string[];
  teams: TeamRow[];
} = {
  headingLeft: "அணிகள்",
  columns: ["எம்", "பி", "எல்", "என்.ஆர்", "PTS"],
  teams: [{
    name: "ஜிடி",
    short: "GT",
    logo: "https://media.dinamani.com/dinamani/2026-02-27/pm7gpn7o/dummy.png",
    badge: "#0EA5E9",
    played: 13,
    won: 9,
    lost: 4,
    nrr: "+0.812",
    pts: 18
  }, {
    name: "சின்ஸ்கே",
    short: "CSK",
    logo: "https://media.dinamani.com/dinamani/2026-02-27/pm7gpn7o/dummy.png",
    badge: "#FACC15",
    played: 13,
    won: 9,
    lost: 4,
    nrr: "+0.812",
    pts: 18
  }, {
    name: "எஸ்.எஸ்.ஜி",
    short: "LSG",
    logo: "https://media.dinamani.com/dinamani/2026-02-27/pm7gpn7o/dummy.png",
    badge: "#60A5FA",
    played: 13,
    won: 9,
    lost: 4,
    nrr: "+0.812",
    pts: 18
  }, {
    name: "எம்.ஐ",
    short: "MI",
    logo: "https://media.dinamani.com/dinamani/2026-02-27/pm7gpn7o/dummy.png",
    badge: "#1D4ED8",
    played: 13,
    won: 9,
    lost: 4,
    nrr: "+0.812",
    pts: 18
  }, {
    name: "ஜிடி",
    short: "GT",
    logo: "https://media.dinamani.com/dinamani/2026-02-27/pm7gpn7o/dummy.png",
    badge: "#EC4899",
    played: 13,
    won: 9,
    lost: 4,
    nrr: "+0.812",
    pts: 18
  }, {
    name: "ஆர்சிபி",
    short: "RCB",
    logo: "https://media.dinamani.com/dinamani/2026-02-27/pm7gpn7o/dummy.png",
    badge: "#F97316",
    played: 13,
    won: 9,
    lost: 4,
    nrr: "+0.812",
    pts: 18
  }, {
    name: "கே.கே.ஆர்",
    short: "KKR",
    logo: "https://media.dinamani.com/dinamani/2026-02-27/pm7gpn7o/dummy.png",
    badge: "#B45309",
    played: 13,
    won: 9,
    lost: 4,
    nrr: "+0.812",
    pts: 18
  }, {
    name: "எஸ்.ஆர்",
    short: "SRH",
    logo: "https://media.dinamani.com/dinamani/2026-02-27/pm7gpn7o/dummy.png",
    badge: "#EA580C",
    played: 13,
    won: 9,
    lost: 4,
    nrr: "+0.812",
    pts: 18
  }, {
    name: "பி.பிகென்ஸ்",
    short: "PBKS",
    logo: "https://media.dinamani.com/dinamani/2026-02-27/pm7gpn7o/dummy.png",
    badge: "#EF4444",
    played: 13,
    won: 9,
    lost: 4,
    nrr: "+0.812",
    pts: 18
  }, {
    name: "டிசி",
    short: "DC",
    logo: "https://media.dinamani.com/dinamani/2026-02-27/pm7gpn7o/dummy.png",
    badge: "#3B82F6",
    played: 13,
    won: 9,
    lost: 4,
    nrr: "+0.812",
    pts: 18
  }]
};
export default function TeamPointsTable(t0) {
  const $ = _c(3);
  const {
    className: t1
  } = t0;
  const className = t1 === undefined ? "" : t1;
  const t2 = "w-full rounded-xl overflow-hidden p-4 " + className;
  let t3;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <div className="overflow-x-auto"><div className="min-w-[680px] rounded-lg"><div className="p-4 bg-012061 text-FFFFFF grid [grid] grid-cols-[minmax(220px,1fr)_64px_64px_64px_96px_64px] "><div className="text-16-tamil-700 ">{TABLE_DATA.headingLeft}</div>{TABLE_DATA.columns.map(_temp)}</div>{TABLE_DATA.teams.map(_temp2)}</div></div>;
    $[0] = t3;
  } else {
    t3 = $[0];
  }
  let t4;
  if ($[1] !== t2) {
    t4 = <div className={t2}>{t3}</div>;
    $[1] = t2;
    $[2] = t4;
  } else {
    t4 = $[2];
  }
  return t4;
}
function _temp2(t, idx) {
  return <div key={t.short + idx} className={"grid [grid] grid-cols-[minmax(220px,1fr)_64px_64px_64px_96px_64px] " + (idx < 4 ? " bg-ECEEF3 border border-E6F8FD" : " bg-FFFFFF") + " px-4 sm:px-6 py-4"}><div className="flex items-center gap-3"><div className="w-[44px] h-[44px] rounded-[5px] overflow-hidden flex items-center justify-center" style={{
        backgroundColor: t.badge
      }}><Image src={t.logo || "https://media.dinamani.com/dinamani/2026-02-27/pm7gpn7o/dummy.png"} alt={t.short} width={20} height={20} /></div><div className="text-18-tamil-600 text-020202">{t.name}</div></div><div className="text-center text-16-english-400 text-020202">{t.played}</div><div className="text-center text-16-english-400 text-020202">{t.won}</div><div className="text-center text-16-english-400 text-020202">{t.lost}</div><div className="text-center text-16-english-400 text-020202">{t.nrr}</div><div className="text-center text-16-english-400 text-020202">{t.pts}</div></div>;
}
function _temp(c, i) {
  return <div key={i} className="text-center text-14-tamil-500">{c}</div>;
}